import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 *
 * @description Takes an array of Trellis spacing tokens as numbers and wraps a `children` prop in Trellis `View`
 * components to re-create the desired padding. This is useful when there isn't a spacing token that fits the UI's needs.
 *
 * @example ```tsx
 * // there is no token for 100px, so we can do
 * // 1000 => 40px
 * // 1300 => 60px
 * <TeamPaddingWrapper paddingInlineStart={[1000, 1300]}>
 *   {children}
 * </TeamPaddingWrapper>
 * ```
 *
 * This will output:
 *
 * ```tsx
 * <View paddingInlineStart="1000">
 *   <View paddingInlineStart="1300">
 *     {children}
 *   </View>
 * </View>
 * ```
 */
export const TeamPaddingWrapper = ({
  children,
  paddingInlineStart
}) => {
  if (!(paddingInlineStart !== null && paddingInlineStart !== void 0 && paddingInlineStart.length)) {
    return children;
  }
  return paddingInlineStart.reduce((prev, token) => /*#__PURE__*/_jsx(View, {
    paddingInlineStart: `${token}`,
    children: prev
  }), children);
};
TeamPaddingWrapper.displayName = 'TeamPaddingWrapper';